import React from 'react';
import { Alert, Button, OverlayTrigger, Tooltip, Modal } from 'react-bootstrap';
import { SportsIDs } from "../../JsonFiles";
import { _Map, Utilities } from '../../Utilities/Utilities';
import { AppSelectedSport } from '../../helper/Constants';
import { getMyContest, getMiniLeagueMyContest } from '../../WSHelper/WSCallings';
import CollectionSlider from "../../views/CollectionSlider";
import * as AppLabels from "../../helper/AppLabels";
import * as WSC from "../../WSHelper/WSConstants";
import Skeleton from 'react-loading-skeleton';
import * as Constants from "../../helper/Constants";
import Images from '../../components/images';
import CricketScorecard from '../scorecard/CricketScorecard';


export default class LiveContest extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            liveContestList: [],
            loadingIndex: -1,
            prizeList: [],
            ShowModal: false,
            selectedMatchId: 53274
        };
    };

    /**
     * @description This function is responsible to get Live Contests response
     * @param status selected tab (Live, Upcoming, Completed)
     */
    getMyContestList(item, idx) {
        if (item.isExpanded) {
            let liveContestList = this.state.liveContestList;
            item['isExpanded'] = false;
            liveContestList[idx] = item;
            this.setState({ liveContestList })
        } else {
            if (item.contest && item.contest.length > 0) {
                let liveContestList = this.state.liveContestList;
                item['isExpanded'] = true;
                liveContestList[idx] = item;
                this.setState({ liveContestList })
            } else {
                var param = {
                    "sports_id": AppSelectedSport,
                    "status": 1,
                    "collection_master_id": item.collection_master_id
                }
                this.setState({ loadingIndex: idx })
                let apiStatus = Constants.SELECTED_GAMET == Constants.GameType.Free2Play ? getMiniLeagueMyContest : getMyContest

                apiStatus(param).then((responseJson) => {
                    this.setState({ loadingIndex: -1 })

                    if (responseJson && responseJson.response_code == WSC.successCode) {
                        let liveContestList = this.state.liveContestList;
                        item['contest'] = responseJson.data;
                        item['isExpanded'] = true;
                        liveContestList[idx] = item;
                        this.setState({ liveContestList })
                        this.setState({ prizeList: responseJson.prize_distibution_detail })
                    }
                })
            }
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.liveContestList !== nextProps.liveContestList) {
            this.setState({ liveContestList: nextProps.liveContestList })
        }
    }

    getContestTabs = (item, idx) => {
        return(
            <div style={{ display:'flex', paddingLeft:30, paddingRight:30, marginBottom:10 }}>
                <div className="my-contest-tab-button-selected">
                    Contests
                </div>
                <div onClick={() => this.handleScorecardClicked(item)} className="my-contest-tab-button">
                    Scorecard
                </div>
            </div>
        )
        
    }

    handleScorecardClicked = item => {
        if(item.league_id == "828") {
            Utilities.showToast(AppLabels.SCORECARD_NOT_AVAILABLE, 3000);
         } else {
             this.setState({ showModal: true, selectedMatchId: item.season_game_uid })
        }
    }

    handleCloseModalClicked = () => {
        this.setState({
            showModal: false
        })
    }

    getPrizeAmount = (prize_data) => {
        let prize_text = "Prizes";
        let is_tie_breaker = 0;
        let prizeAmount = { 'real': 0, 'bonus': 0, 'point': 0 };
        return (
            <React.Fragment>
                {
                    prize_data && prize_data.map(function (lObj, lKey) {
                        var amount = 0;
                        if (lObj.max_value) {
                            amount = parseFloat(lObj.max_value);
                        } else {
                            amount = parseFloat(lObj.amount);
                        }
                        if (lObj.prize_type == 3) {
                            is_tie_breaker = 1;
                        }
                        if (lObj.prize_type == 0) {
                            prizeAmount['bonus'] = parseFloat(prizeAmount['bonus']) + amount;
                        } else if (lObj.prize_type == 2) {
                            prizeAmount['point'] = parseFloat(prizeAmount['point']) + amount;
                        } else {
                            prizeAmount['real'] = parseFloat(prizeAmount['real']) + amount;
                        }
                    })
                }
                {
                    is_tie_breaker == 0 && prizeAmount.real > 0 ?
                        <span className="contest-prizes">{Utilities.getMasterData().currency_code}{parseFloat(prizeAmount.real).toFixed(0)}</span>
                        : is_tie_breaker == 0 && prizeAmount.bonus > 0 ? <span className="contest-prizes" ><i className="icon-bonus" width="13px" height="14px" />{parseFloat(prizeAmount.bonus).toFixed(0)}</span>
                            : is_tie_breaker == 0 && prizeAmount.point > 0 ? <span style={{ display: 'inlineBlock' }}> <img style={{ marginTop: '3px' }} src={Images.IC_COIN} width="12px" height="12px" />{parseFloat(prizeAmount.point).toFixed(0)}</span>
                                : AppLabels.PRIZES
                }
            </React.Fragment>
        )


    }

    render() {
        let { ContestDetailShow, openLeaderboard } = this.props;
        const { showModal, selectedMatchId } = this.state;
        return (
            <div>
                {
                    this.state.liveContestList.length > 0 &&
                    _Map(this.state.liveContestList, (item, idx) => {
                        return (
                            <div key={idx} className={"contest-card live-contest-card live-contest-card-new" + (Constants.SELECTED_GAMET == Constants.GameType.MultiGame && item.match_list && item.match_list.length > 1 ? ' contest-card-with-collection' : '')}>                          
                                {
                                    item.custom_message != '' && item.custom_message != null &&
                                    <div className="bhopu-mycontest">
                                        <OverlayTrigger trigger={['click']} placement="left" overlay={
                                            <Tooltip id="tooltip" className="tooltip-featured">
                                                <strong>{item.custom_message} </strong>
                                            </Tooltip>
                                        }>
                                            <i className="icon-megaphone" onClick={(e) => e.stopPropagation()}></i>
                                        </OverlayTrigger>
                                    </div>

                                }
                                <div onClick={() => this.getMyContestList(item, idx)} className={"contest-card-header pointer-cursor" + (item.isExpanded ? ' pb15' : '')}>
                                    <ul>
                                        {
                                            (!item.match_list || item.match_list.length < 2) &&
                                            <React.Fragment>
                                                <li className="team-left-side">
                                                    <div className="team-content-img">
                                                        {Constants.SELECTED_GAMET != Constants.GameType.MultiGame &&
                                                            <img src={item.home_flag ? Utilities.teamFlagURL(item.home_flag) : ""} alt="" />
                                                        }
                                                        {Constants.SELECTED_GAMET == Constants.GameType.MultiGame &&
                                                            <img src={item.match_list ? Utilities.teamFlagURL(item.match_list[0].home_flag) : ""} alt="" />
                                                        }
                                                    </div>
                                                    <div className="contest-details-action">
                                                        {Constants.SELECTED_GAMET != Constants.GameType.MultiGame &&
                                                            <React.Fragment>
                                                                <div className="contest-details-first-div">{item.home}</div>
                                                                {
                                                                    AppSelectedSport == SportsIDs.cricket ?
                                                                        item.score_data && item.score_data[1] ?
                                                                            <div className="contest-details-sec-div">
                                                                                {item.score_data[1].home_team_score}-{(item.score_data[1].home_wickets) ? item.score_data[1].home_wickets : 0}
                                                                                <span className="gray-color-class"> {(item.score_data[1].home_overs) ? item.score_data[1].home_overs : 0} {item.score_data[2] ? ' & ' : ''} </span>
                                                                                {
                                                                                    item.score_data[2] && <div className="contest-details-sec-div second-inning">
                                                                                        {item.score_data[2].home_team_score}-{(item.score_data[2].home_wickets) ? item.score_data[2].home_wickets : 0}
                                                                                        <span className="gray-color-class"> {(item.score_data[2].home_overs) ? item.score_data[2].home_overs : 0} </span>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                            :
                                                                            <div className="contest-details-sec-div">{0}-{0}<span className="gray-color-class"> 0 </span></div>
                                                                        :
                                                                        (item.score_data) ?
                                                                            <div className="contest-details-sec-div">{item.score_data.home_score}</div>
                                                                            :
                                                                            <div className="contest-details-sec-div">0</div>
                                                                }
                                                            </React.Fragment>
                                                        }
                                                        {Constants.SELECTED_GAMET == Constants.GameType.MultiGame && item.match_list.length > 1 &&
                                                            <React.Fragment>
                                                                <div className="contest-details-first-div">{item.match_list ? item.match_list[0].home : ""}</div>
                                                                {
                                                                    AppSelectedSport == SportsIDs.cricket ?
                                                                        item.match_list && item.match_list[0].score_data[1] ?
                                                                            <div className="contest-details-sec-div">
                                                                                {item.match_list[0].score_data[1].home_team_score}-{(item.match_list[0].score_data[1].home_wickets)
                                                                                    ?
                                                                                    item.match_list[0].score_data[1].home_wickets : 0}
                                                                                <span className="gray-color-class">
                                                                                    {(item.match_list[0].score_data[1].home_overs) ? item.match_list[0].score_data[1].home_overs : 0}
                                                                                </span>
                                                                            </div>
                                                                            :
                                                                            <div className="contest-details-sec-div">
                                                                                {0}-{0}
                                                                                <span className="gray-color-class"> 0 </span>
                                                                            </div>
                                                                        :
                                                                        (item.match_list) ?
                                                                            <div className="contest-details-sec-div">{item.match_list[0].score_data.home_score}</div>
                                                                            :
                                                                            <div className="contest-details-sec-div">0</div>
                                                                }
                                                            </React.Fragment>
                                                        }
                                                    </div>
                                                </li>
                                                <li className="progress-middle">
                                                    <div className="progress-middle-div">
                                                        <p>{item.league_name}</p>
                                                        <span className="progress-span">
                                                            {AppLabels.IN_PROGRESS}
                                                        </span>
                                                        {/*item.sports_id == '7' && <button className='scorecard-button scorecard-green' onClick={() => this.props.goToScorecard(item.season_game_uid)} >
                                                            Scorecard
                                                    </button>*/}
                                                    </div>
                                                </li>
                                                <li className="team-right-side">
                                                    <div className="contest-details-action">
                                                        {Constants.SELECTED_GAMET != Constants.GameType.MultiGame &&
                                                            <React.Fragment>
                                                                <div className="contest-details-first-div">{item.away}</div>
                                                                {
                                                                    AppSelectedSport == SportsIDs.cricket ?
                                                                        item.score_data && item.score_data[1] ?
                                                                            <div className="contest-details-sec-div">
                                                                                {item.score_data[1].away_team_score}-{(item.score_data[1].away_wickets) ? item.score_data[1].away_wickets : 0}
                                                                                <span className="gray-color-class"> {(item.score_data[1].away_overs) ? item.score_data[1].away_overs : 0} {item.score_data[2] ? ' & ' : ''} </span>
                                                                                {
                                                                                    item.score_data[2] && <div className="contest-details-sec-div second-inning">
                                                                                        {item.score_data[2].away_team_score}-{(item.score_data[2].away_wickets) ? item.score_data[2].away_wickets : 0}
                                                                                        <span className="gray-color-class"> {(item.score_data[2].away_overs) ? item.score_data[2].away_overs : 0} </span>
                                                                                    </div>
                                                                                }
                                                                            </div>
                                                                            :
                                                                            <div className="contest-details-sec-div">{0}-{0}<span className="gray-color-class"> 0 </span></div>
                                                                        :
                                                                        (item.score_data) ?
                                                                            <div className="contest-details-sec-div">{item.score_data.away_score}</div>
                                                                            :
                                                                            <div className="contest-details-sec-div">0</div>
                                                                }
                                                            </React.Fragment>

                                                        }
                                                        {Constants.SELECTED_GAMET == Constants.GameType.MultiGame && item.match_list.length > 1 &&
                                                            <React.Fragment>
                                                                <div className="contest-details-first-div">{item.match_list ? item.match_list[0].away : ""}</div>
                                                                {
                                                                    AppSelectedSport == SportsIDs.cricket ?
                                                                        item.match_list && item.match_list.score_data ?
                                                                            <div className="contest-details-sec-div">
                                                                                {item.match_list[0].score_data[1].away_team_score}-{(item.match_list[0].score_data[1].away_wickets) ? item.match_list[0].score_data[1].away_wickets : 0}<span className="gray-color-class"> {(item.match_list[0].score_data[1].away_overs) ? item.match_list[0].score_data[1].away_overs : 0}</span></div>
                                                                            :
                                                                            <div className="contest-details-sec-div">{0}-{0}<span className="gray-color-class"> 0 </span></div>
                                                                        :
                                                                        (item.match_list) ?
                                                                            <div className="contest-details-sec-div">{item.match_list[0].score_data.away_score}</div>
                                                                            :
                                                                            <div className="contest-details-sec-div">0</div>
                                                                }
                                                            </React.Fragment>

                                                        }

                                                    </div>
                                                    <div className="team-content-img">
                                                        {Constants.SELECTED_GAMET != Constants.GameType.MultiGame &&
                                                            <img src={item.away_flag ? Utilities.teamFlagURL(item.away_flag) : ""} alt="" />
                                                        }
                                                        {Constants.SELECTED_GAMET == Constants.GameType.MultiGame &&
                                                            <img src={item.match_list ? Utilities.teamFlagURL(item.match_list[0].away_flag) : ""} alt="" />
                                                        }
                                                    </div>
                                                </li>
                                            </React.Fragment>
                                        }
                                        {Constants.SELECTED_GAMET == Constants.GameType.MultiGame && item.match_list.length > 1 &&
                                            <li className="progress-middle">
                                                <div className="team-content">
                                                    <p className="collection_name">{item.collection_name}</p>
                                                    <div className="collection-match-info">
                                                        {item.match_list.length} {AppLabels.MATCHES_SM}
                                                        <span className="circle-divider"></span>
                                                        {item.league_name}
                                                    </div>
                                                </div>
                                            </li>
                                        }
                                    </ul>
                                </div>
                                {Constants.SELECTED_GAMET == Constants.GameType.MultiGame && item.match_list.length > 1 &&
                                    <div onClick={() => this.getMyContestList(item, idx)} className="mycontest-collection-wrapper">
                                        <CollectionSlider contestSliderData={item} collectionInfo={false} isFrom={'LiveContest'} />
                                    </div>
                                }
                                <div className="contest-card-body-wrapper">
                                    {item.isExpanded &&
                                        <div className="m-b-15">
                                            {
                                                item.custom_message != '' && item.custom_message != null &&
                                                <Alert variant="warning" className="alert-warning msg-alert-container">
                                                    <div className="msg-alert-wrapper">
                                                        <span className=""><i className="icon-megaphone"></i></span>
                                                        <span>{item.custom_message}</span>
                                                    </div>
                                                </Alert>

                                            }
                                        </div>
                                    }

                                {
                                    item.isExpanded && item.sports_id == '7' && this.getContestTabs(item, idx)
                                }

                                    {
                                        item.isExpanded && _Map(item.contest, (childItem, idx) => {
                                            return (
                                                <div key={idx} className={"contest-card-body xmb20 " + (idx != 0 ? "mt15" : '')}>

                                                    <div className="contest-card-body-header cursor-pointer" onClick={() => ContestDetailShow(childItem, item)}>
                                                        <div className="contest-details">

                                                            <div className="contest-details-action">
                                                                {
                                                                    childItem.contest_title ?
                                                                        <h4>
                                                                            {childItem.contest_title}
                                                                        </h4>
                                                                        :
                                                                        <h4>
                                                                            <span className=" text-capitalize">{AppLabels.WIN} </span>
                                                                            <span>
                                                                                {this.getPrizeAmount(childItem.prize_distibution_detail)}
                                                                            </span>
                                                                        </h4>
                                                                }
                                                                {
                                                                    childItem.max_bonus_allowed != '0' &&
                                                                    <ul className="list-inner">

                                                                        <li className='f-red'>
                                                                            {childItem.max_bonus_allowed}{'% '}{AppLabels.BONUS}
                                                                        </li>
                                                                    </ul>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div>
                                                            {
                                                                childItem.entry_fee > 0 ?
                                                                    <><span style={{ fontWeight: 800 }}> Entry Fee </span>
                                                                        {
                                                                            childItem.currency_type == 2 ?
                                                                                <img className="img-coin" alt='' src={Images.IC_COIN} />
                                                                                :
                                                                                Utilities.getMasterData().currency_code
                                                                        }
                                                                        {childItem.entry_fee}
                                                                    </>
                                                                    : AppLabels.FREE + ' '
                                                            }
                                                        </div>
                                                        <div onClick={(e) => openLeaderboard(e, childItem, item)} className="contest-details-right absolute">
                                                            <a>
                                                                <i className="icon-standings f-sm"></i>
                                                                <span>{AppLabels.STANDINGS}</span>
                                                            </a>
                                                        </div>
                                                    </div>

                                                    <div>
                                                        <table className="contest-listing-table">
                                                            <thead>
                                                                <tr>
                                                                    <th><span>{AppLabels.Team}</span></th>
                                                                    <th><span>{AppLabels.Pts}</span></th>
                                                                    <th><span className="rank-label">{AppLabels.RANK}</span></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    _Map(childItem.teams, (teamItem, idx) => {
                                                                        return (
                                                                            <tr key={teamItem.lineup_master_id}>
                                                                                <td className="team-name">
                                                                                    {teamItem.team_name}
                                                                                    {
                                                                                        Constants.SELECTED_GAMET == Constants.GameType.DFS && Utilities.getMasterData().a_guru == '1' && teamItem.is_pl_team && teamItem.is_pl_team == '1' &&
                                                                                        <img style={{ marginLeft: 10 }} src={Images.PL_LOGO} alt=''></img>
                                                                                    }
                                                                                </td>
                                                                                <td>{teamItem.total_score}</td>
                                                                                <td className={"contest-rank" + (teamItem.is_winner == 1 ? ' success' : '')}>
                                                                                    <a>
                                                                                        <span>
                                                                                            {
                                                                                                teamItem.is_winner == 1 &&
                                                                                                <i className="icon-trophy"></i>
                                                                                            }
                                                                                        </span>
                                                                                        {teamItem.game_rank}
                                                                                    </a>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>                                                </div>
                                            )
                                        })
                                    }
                                    {

                                        (this.state.loadingIndex === idx) && <div className="contest-list m border shadow-none">
                                            <div className="shimmer-container">
                                                <div className="shimmer-top-view">
                                                    <div className="shimmer-line">
                                                        <Skeleton height={9} />
                                                        <Skeleton height={6} />
                                                        <Skeleton height={4} width={100} />
                                                    </div>
                                                    <div className="shimmer-image">
                                                        <Skeleton width={30} height={30} />
                                                    </div>
                                                </div>
                                                <div className="shimmer-bottom-view">
                                                    <div className="progress-bar-default w-100">
                                                        <Skeleton height={6} />
                                                        <div className="d-flex justify-content-between">
                                                            <Skeleton height={4} width={60} />
                                                            <Skeleton height={4} width={60} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        )
                    })
                }
                <Modal
                    show={showModal}
                    dialogClassName="custom-modal"
                    className="center-modal"
                    scrollable={true}
                    style={{ display:'flex', flex:1, borderRadius:0 }}
                >
                    <Modal.Body style={{
                        maxHeight: 'calc(100vh)',
                        overflowY: 'auto',
                        padding:0
                        }}
                        >
                        <div style={{ backgroundColor:'#F2F2F2' }}>
                            <CricketScorecard 
                                matchId={selectedMatchId}
                                closeModal={this.handleCloseModalClicked}
                            />
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }

}